<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="kpis"
          item-key="uid"
          show-select
          :search="search"
          class="elevation-1 table"
          @click:row="copyUrl"
        >
          <template v-slot:top>
            <v-container class="pl-5 pr-5 text-center">
              <v-row justify="start">
                <v-col cols="6" class="white">
                  <v-select
                    v-model="branch"
                    :items="setBranchFilter"
                    item-text="title"
                    item-value="value"
                    label="SUCURSAL"
                    @change="changeFilterBranch"
                  ></v-select>
                </v-col>
                <v-col cols="6" class="white">
                  <v-file-input
                    ref="fileupload"
                    :rules="rulesFile"
                    @change="importRegister"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    show-size
                    counter
                    :clearable="true"
                    v-model="file"
                    label="File input"
                  ></v-file-input>
                </v-col>
                <v-col cols="6" class="white">
                  <v-select
                    ref="selectActions"
                    v-model="action"
                    :items="actions"
                    item-text="title"
                    item-value="value"
                    label="ACCIONES"
                    @change="changeActions"
                  ></v-select>
                </v-col>
              </v-row>
            </v-container>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon color="error" @click="deleteItem(item)">
              delete
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row justify="end">
      <v-col cols="4" class="d-flex flex-row-reverse">
        <v-btn @click="openForm = true" class="mx-2" fab dark color="primary">
          <v-icon dark>
            add
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-dialog v-model="dialogController.open" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          {{ dialogController.title }}
        </v-card-title>

        <v-card-text class="mt-2">
          {{ dialogController.content }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogController.open = false">
            Cancelar
          </v-btn>
          <v-btn color="error" @click="dialogController.functionSucces">
            Eliminar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="openForm" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Carga de KPI's
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-2">
          <v-form ref="formRef" v-model="valid" lazy-validation>
            <v-select
              v-bind="form.branch.props"
              v-model="form.branch.value"
              :items="branchs"
              item-text="title"
              item-value="value"
              single-line
              prepend-icon="business"
            ></v-select>
            <v-text-field
              v-bind="form.image.props"
              v-model="form.image.value"
              single-line
              prepend-icon="photo_camera"
            ></v-text-field>
            <v-textarea
              v-bind="form.description.props"
              v-model="form.description.value"
              name="input-7-4"
              prepend-icon="description"
            ></v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="openForm = false">
            Cancelar
          </v-btn>
          <v-btn color="accent" @click="addKpi">
            Guardar
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { errorMessage } from "@/services/MessageService";
import { loaderDone, loaderStart } from "@/services/LoaderService";
import Indicator from "@/models/indicator";
import { mapActions, mapState } from "vuex";
import csvjson from "csvjson";
import { showMessage } from "@/services/MessageService";

export default {
  data() {
    return {
      branch: "",
      valid: true,
      selected: [],
      file: null,
      rulesFile: [
        value =>
          !value ||
          value.size < 5000000 ||
          "El archivo debe pesar menos de 5 MB!"
      ],
      search: "",
      dialogController: {
        open: false,
        functionSucces: null,
        functionCancel: null,
        title: "",
        content: ""
      },
      openForm: false,
      headers: [
        {
          text: "Sucursal",
          align: "start",
          value: "branch"
        },
        { text: "Archivo", value: "url" },
        { text: "Descripcion", value: "description" },
        { text: "Acciones", value: "actions", sortable: false }
      ],
      kpis: [],
      actions: [
        {
          title: "Eliminar",
          value: 0
        }
      ],
      action: "",
      currentKpiAction: {},
      form: Indicator.getRegisterForm()
    };
  },
  computed: {
    ...mapState("checklist", ["branchs"]),
    ...mapState("user", ["userAccess", "userBranch"]),
    setBranchFilter() {
      const filterBranch = [];
      if (this.userAccess["add-kpi"] && !this.userAccess["admin-kpi"]) {
        const branch = this.branchs.find(
          branch => branch.value === this.userBranch
        );
        filterBranch.push(branch);
        return filterBranch;
      }
      if (this.userAccess["admin-kpi"]) {
        filterBranch.push({
          title: "Todo",
          value: ""
        });
        this.branchs.forEach(branch => {
          filterBranch.push(branch);
        });
        return filterBranch;
      }
      return [];
    }
  },
  async mounted() {
    await this.getBranch();
    if (this.userAccess["add-kpi"] && !this.userAccess["admin-kpi"]) {
      this.getKpis(this.userBranch);
    } else {
      this.getKpis("");
    }
  },
  methods: {
    ...mapActions("checklist", ["getBranch"]),
    ...mapActions("dashboard", [
      "saveKpi",
      "getDataKpis",
      "deleteKpi",
      "deleteMultiplesKpis",
      "saveImportRegisters"
    ]),
    reset() {
      this.$refs.formRef.reset();
    },
    async copyUrl(item) {
      await navigator.clipboard.writeText(item.url);
      showMessage({
        message: "Copiado",
        color: "success"
      });
    },
    getNumberBranch(value) {
      const branch = this.branchs.find(
        branch => branch.title.toLowerCase() === value.toLowerCase()
      );
      return branch ? branch.value : -1;
    },
    getTitleBranch(key) {
      const object = this.branchs.find(branch => branch.value === key);
      return object ? object.title : "Sin sucursal";
    },
    formatRecords(array) {
      const records = [];
      for (const item of array) {
        records.push({
          branch: this.getNumberBranch(item.Sucursal),
          description: item.Descripcion,
          url: item.Url.replace(/\s/g, ""),
          active: true
        });
      }
      return records;
    },
    async importRegister(file) {
      if (file) {
        let array = [];
        const reader = new FileReader();
        reader.readAsText(file);
        reader.onload = async () => {
          loaderStart();
          const options = {
            delimiter: ",",
            quote: '"'
          };
          array = await csvjson.toObject(reader.result, options);
          array = this.formatRecords(array);
          await this.saveImportRegisters(array);
          this.getKpis(this.branch);
          loaderDone();
        };
      }
    },
    async addKpi() {
      loaderStart();
      try {
        if (this.$refs.formRef.validate()) {
          const kpiData = {
            branch: this.form.branch.value,
            url: this.form.image.value.replace(/\s/g, ""),
            description: this.form.description.value,
            active: true
          };
          await this.saveKpi(kpiData);
          this.reset();
          this.getKpis(this.branch);
          this.openForm = false;
        }
        loaderDone();
      } catch (error) {
        errorMessage("No se pudo guardar el kpi");
        loaderDone();
      }
    },
    changeFilterBranch(value) {
      this.getKpis(value);
    },
    async changeActions(value) {
      switch (value) {
        case 0:
          this.dialogController.open = true;
          this.dialogController.title = "Eliminar indicadores";
          this.dialogController.content =
            "Estas seguro de eliminar los indicadores";
          this.dialogController.functionSucces = this.confirmDeleteMultiple;
          break;
      }
      this.$refs.selectActions.reset();
    },
    async getKpis(branch) {
      loaderStart();
      try {
        const kpiSnap = await this.getDataKpis(branch);
        this.kpis.splice(0, this.kpis.length);
        kpiSnap.forEach(doc => {
          const data = {
            branch: this.getTitleBranch(doc.data().branch),
            url: doc.data().url.replace(/\s/g, ""),
            description: doc.data().description,
            uid: doc.id,
            active: doc.data().active
          };
          this.kpis.push(data);
        });
        loaderDone();
      } catch (error) {
        errorMessage("No se pudieron obtener los indicadores" + error);
        loaderDone();
      }
    },
    deleteItem(item) {
      this.currentKpiAction = item;
      this.dialogController.open = true;
      this.dialogController.title = "Eliminar indicador";
      this.dialogController.content = "Estas seguro de eliminar el indicador";
      this.dialogController.functionSucces = this.confirmDelete;
    },
    async confirmDeleteMultiple() {
      loaderStart();
      this.dialogController.open = false;
      await this.deleteMultiplesKpis(this.selected);
      this.getKpis(this.branch);
      loaderDone();
    },
    async confirmDelete() {
      loaderStart();
      this.dialogController.open = false;
      await this.deleteKpi(this.currentKpiAction.uid);
      this.getKpis(this.branch);
      loaderDone();
    }
  }
};
</script>

<style>
.table > .v-data-table__wrapper > table > tbody > tr:hover {
  cursor: pointer;
}
</style>
